export default __webpack_public_path__ + "static/media/work-setting.395d0c4d.svg";